import { getMainSiteUrl, MAIN_SITE_URL, resolveSiteUrl } from "./appConfig";

export const SITE = {
  name: "CAF Sports",
  url: resolveSiteUrl(),
  mainUrl: MAIN_SITE_URL,
  /** Use in href — dev-aware (localhost:3001 when testing landing locally). */
  getMainSiteUrl,
  portfolioUrl: "https://eslam-emam-portfolio.netlify.app/",
  facebookUrl: "https://www.facebook.com/ConsultantArabFlooring.CAFsports",
  whatsappNumber: "+201141227755",
  phones: {
    egyptPrimary: "+201141227755",
    egyptSecondary: "+201126484032",
    uae: "+971543575745",
  },
  emails: {
    info: "info@caf-sports.com",
    uae: "sales_uae@caf-sports.com",
    egypt: "sales_egy@caf-sports.com",
  },
  maps: {
    uae: "https://www.google.com/maps/place/United+Arab+Emirates/@24.3361314,51.3062024,7z/data=!3m1!4b1!4m6!3m5!1s0x3e5e48dfb1ab12bd:0x33d32f56c0080aa7!8m2!3d23.424076!4d53.847818!16zL20vMGoxejg?entry=ttu",
    egypt: "https://maps.app.goo.gl/9TjhPheEsVWgsdsB7",
  },
  mapEmbeds: {
    egypt:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d220360.0898661788!2d31.235711!3d30.0444196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583fa60b21beeb%3A0x79dfb296e8423bba!2sNasr%20City%2C%20Cairo%20Governorate!5e0!3m2!1sen!2seg!4v1710000000000!5m2!1sen!2seg",
    uae: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5866142.167765116!2d51.286984537853854!3d23.905649532988534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4343d3e94b29%3A0x2022a62e58a1c53b!2sUnited%20Arab%20Emirates!5e0!3m2!1sen!2sus!4v1646997782997!5m2!1sen!2sus",
  },
};

export const SOCIAL_LINKS = [
  { id: "facebook", href: SITE.facebookUrl, external: true },
  {
    id: "whatsapp",
    href: `https://wa.me/${SITE.whatsappNumber.replace(/\D/g, "")}`,
    external: true,
  },
  { id: "phone", href: `tel:${SITE.phones.egyptSecondary}`, external: false },
];
